import type { BasePlaceEntity } from '@placer-ui/types';
import { useExploreUIState } from 'features/explore/context/use-explore-ui-state';
import { isAddressType } from 'utils/poi-provider/poi-provider';
import { ADDRESS_ENTITY, COORDINATES_ENTITY } from 'features/explore/constants';
import { ADDRESS_TITLE } from 'core/constants/address';
import { useSelectCategoriesData } from 'store/configuration/categories/selectors/selectors-hooks';
import { getCategoryIconUrlWithFallback } from 'core/entities/category/utils';
import { useSegmentCallback } from 'hooks/use-segment-callback/use-segment-callback';
import { PlacePOI } from 'core/entities';

export const useExploreListItemName = (poi: BasePlaceEntity) => {
    const { customPoiAddresses } = useExploreUIState();

    return isAddressType(poi) &&
        (!!customPoiAddresses[poi.provider_data?.entity_id || poi.id] ||
            poi.provider_data?.entity_id === ADDRESS_ENTITY ||
            (poi.category !== 'Address' && poi.provider_data?.entity_id !== COORDINATES_ENTITY))
        ? ADDRESS_TITLE
        : poi.name;
};

export const useExploreListItemLogoProps = (poi: BasePlaceEntity) => {
    const categoriesIconData = useSelectCategoriesData();
    const categoryIconUrl = getCategoryIconUrlWithFallback({
        categoriesIconData,
        info: poi,
    });

    return {
        logoUrl: !poi.provider_data?.provider ? poi.logo_img : undefined,
        icon: !poi.provider_data?.provider ? categoryIconUrl : undefined,
        poiType: isAddressType(poi) ? 'address' : poi.type,
        name: poi.name,
    };
};

export const useExploreListSelect = (
    poi: BasePlaceEntity,
    isSelected: boolean,
    onSelect?: (isSelected: boolean) => void,
) => {
    const { track } = useSegmentCallback();
    const category = PlacePOI.getPrimaryCategory(poi);

    return () => {
        if (onSelect) {
            track({
                category: 'Explore',
                action: 'POI Selected In Menu',
                label: category,
            });
            onSelect(!isSelected);
        }
    };
};
